import { IApplicationState } from '../../types/redux';

export function selectReturnUrl(state: IApplicationState) {
  return state.page.returnUrl;
}
